export default '/build/7552c16d.svg'